import type { FC } from 'react';
import { Circle, Path, Svg } from './primitives';

export interface CompassMarkProps {
  readonly size?: number;
  readonly color?: string;
  readonly accent?: string;
}

const VIEW_BOX = '0 0 100 40';

function CompassMarkShapes({ color, accent }: { color: string; accent: string }) {
  return (
    <>
      <Circle cx={5} cy={20} r={3.5} fill={color} />
      <Path
        d="M 10 20 H 24 L 28 8 L 34 32 L 40 4 L 46 32 L 52 8 L 58 20 H 78"
        stroke={accent}
        strokeWidth={3.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <Path
        d="M 80 20 H 96 M 88 13 L 96 20 L 88 27"
        stroke={color}
        strokeWidth={3.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  );
}

export const CompassMark: FC<CompassMarkProps> = ({ size = 80, color = '#000', accent }) => {
  const height = size * 0.4;
  return (
    <Svg width={size} height={height} viewBox={VIEW_BOX} fill="none">
      <CompassMarkShapes color={color} accent={accent ?? color} />
    </Svg>
  );
};

export const COMPASS_MARK_SYMBOL_ID = 'compass-mark';

/**
 * For web pages that repeat the mark many times: render this once, then each
 * repeat is `<svg><use href="#compass-mark" /></svg>` instead of the full shapes.
 * Theme variables passed as colours still follow the active theme. Web only.
 */
export const CompassMarkSymbol: FC<{ readonly color: string; readonly accent: string }> = ({
  color,
  accent,
}) => (
  <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
    <symbol id={COMPASS_MARK_SYMBOL_ID} viewBox={VIEW_BOX}>
      <CompassMarkShapes color={color} accent={accent} />
    </symbol>
  </svg>
);
